export const emptySelect = {value: "", label: ""};